// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingSpinner_wrapper__rApgU","spinner":"LoadingSpinner_spinner__Ps+fd","spin":"LoadingSpinner_spin__g0J6L"};